import { render } from "./QuantityTitle.vue?vue&type=template&id=263e86c6&scoped=true"
import script from "./QuantityTitle.vue?vue&type=script&lang=js"
export * from "./QuantityTitle.vue?vue&type=script&lang=js"

import "./QuantityTitle.vue?vue&type=style&index=0&id=263e86c6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-263e86c6"

export default script